module.exports = __webpack_public_path__ + "static/media/icon_error.def72e66.svg";